'use strict';

const angular = require('angular');
import * as Blockly from 'blockly';
import { ControlBlocklyBlocks } from './blockly.custom.block';

/**
 * Initialize Blockly code editor with its toolbox
 */
export class BlocklyComponent {
  /**
   * @type {*}@memberof BlocklyComponent
   */
  codeEditor: any;

  /**
   * @type {*}@memberof BlocklyComponent
   */
  ngNotification: any;

  /**
   * @type {*}@memberof BlocklyComponent
   */
  codeEditorVal: any;

  /**
   * @type {*}@memberof BlocklyComponent
   */
  globleCodeEditor: Boolean;

  /**
   * @type {*}@memberof BlocklyComponent
   */
  maximized: Boolean;

  /**
   * @type {*}@memberof BlocklyComponent
   */
  globleMethods: any = [];
  /**
   * @type {*}@memberof BlocklyComponent
   */
  $element: any;

  /**
   * Utility service
   *
   * @type {*}@memberof BlocklyComponent
   */
  Util: any;

  controlFieldNames: any = [];

  controlDataFieldNames: any = [];

  dataFieldNameBlocks: any = ['custom-property-value-setter', 'custom-property-value-getter', 'auto_next_number_block',
                              'custom-date-diff', 'custom-date-add-subtract', 'minmax_datevalue', 'api_data_clone'];

  fieldNameBlocks: any = ['custom-property-setter', 'custom-property-setter_by_getter', 'custom-property-getter', 'custom-reset-repeating-table', 'custom-get-repeating-table-rows', 'minmax_datevalue'];

  allCustomBlocks: any = ['custom-property-value-setter', 'custom-property-value-getter',
                          'custom-property-setter', 'custom-property-setter_by_getter', 'custom-property-getter', 'custom-reset-repeating-table',
                          'sp_value_getter', 'sp_value_comparator', 'auto_next_number_block', 'auto_next_number_suffix_block', 'custom_math_to_fixed', 'custom-get-repeating-table-rows',
                          'set_timeout', 'clear_timeout', 'set_time_interval', 'clear_time_interval', 'minmax_datevalue', 'api_data_clone'];

  
    http: any;
    apiNames: any;
    showSpinner: any;
    constructor(Notification, $element, Util, config,$http, PROJECTNAME) {
    let self = this;
    self.http = $http;
    self.$element = $element;
    self.ngNotification = Notification;
    self.Util = Util;
    let viewNames = self.Util.getCurrentFormViewNames();
    let fieldNames = self.Util.getFieldNames();
    fieldNames.forEach(data => {
      self.controlFieldNames.push(data.key);
    });
    let dataFieldNames = self.Util.getDataFieldNames();
    dataFieldNames.forEach(data => {
      if(self.controlDataFieldNames.indexOf(data.key) == -1) {
        self.controlDataFieldNames.push(data.key);
      }
    });
    let formID = config.formID;
    let projectName = PROJECTNAME.replaceAll("&#39;", "'");
    let projectId = config.formDetail.id ? config.formDetail.id.projectId : undefined;
    let instanceGroupId = config.formDetail.id ? config.formDetail.id.instanceGroupId : undefined;
    let apiList = self.Util.getAllAPIConnections(formID,instanceGroupId,projectId);
    let projectList = self.Util.getProjectList();
    apiList.then(function (response) {
      projectList.then(function (projects) {
      const apiLists =  response.data.entity.length ? response.data.entity.filter((el)=> el.status == 'Established') : [];
      ControlBlocklyBlocks({
        fieldNames, 
        dataFieldNames, 
        config,
        Util,
        systemSingleValue: self.Util.getFixedFields(true), 
        systemMultiValue: self.Util.getFixedFields(false),
        apiNames: apiLists,
        $http,
        projects, 
        projectName,
        projectId,
        viewNames,
        Notification
       }); 

      setTimeout(() => {
        self.initCodeEditor();
      }, 10);
      if (self.$element && self.$element.parent() && $(self.$element.parent()[0])) {
        $(self.$element.parent()[0]).removeClass('loading')
      }
    });

		}, function (err) {
      console.log(err);
		});

    //Set globle methods blocks into toolbox before create instance of Blockly
    self.setGlobleMethods();
    self.setGlobleMethodDefination('noopMethod');
  }

  $onChanges(changedProps){
    if(changedProps && changedProps.maximized != undefined) {
      this.resizeHandler();
    }
  }

  /**
   * @brief      Destroy existing code editor view and initialize new instance of code editor on '#codeEditorWindow' view.
   *
   * @return     null
   */
  initCodeEditor() {
    let self = this;
    let elCodeEditorWindow = self.$element.find('#codeEditorWindow')[0];
    if(!elCodeEditorWindow) {
      return;
    }

    if(!Blockly) {
      console.error('Blockly is not defined');
      return;
    }

    (<any>window)['codeEditor'] = self.codeEditor  = Blockly.inject(elCodeEditorWindow, {
      toolbox: self.$element.find('#toolbox')[0],
      move:{
          scrollbars: true,
          drag: true,
          wheel: true
      }
    });
    self.setVal(self.codeEditorVal);
    self.resizeHandler();
    angular.element(window).on('resize.blocklyeditor', () => {
      self.resizeHandler();
    });
  }
  
  setVal(val) {
    let self = this;
    if(!self.codeEditor) {
      self.codeEditorVal = val;
      return;
    }

    self.codeEditorVal = undefined;
    if(val && typeof val == 'string') {
      let xmlVal = Blockly.Xml.textToDom(val);
      angular.element(xmlVal).children().each((ind, child) => {
        self.resetControlBlockIfFieldNameNotFound(child);
        self.resetControlBlockIfDataFieldNameNotFound(child);
        let typeName = child.getAttribute('type') || '';
        if(typeName && typeName.indexOf('fn_') == 0) {
          self.setGlobleMethodDefination(typeName.replace('fn_', ''));
        }
      });
      Blockly.Xml.domToWorkspace(xmlVal, self.codeEditor);
    }
    self.resizeHandler();    
  }

  resetControlBlockIfFieldNameNotFound(child) {
    let self = this;
    let typeName = child.getAttribute('type') || '';
    if(self.fieldNameBlocks.indexOf(typeName) != -1) {
      self.resetBlockVal(child);
    }

    self.fieldNameBlocks.forEach((blockType) => {
      let childs = angular.element(child).find('block[type='+ blockType +']');
      if(childs.length) {
        childs.each((ind, item) => {
          self.resetBlockVal(item);
        });
      }
    });
  }

  resetBlockVal(item) {
    let self = this;
    item = angular.element(item);
    let controlName = item.find(' > field[name=CONTROL_NAME]').text();
    if(self.controlFieldNames.indexOf(controlName) == -1) {
      item.find(' > field[name=CONTROL_NAME]').text('');
      item.find(' > field[name=PROPERTY_NAME]').text('');
      item.find(' > field[name=PROPERTY_VALUE]').text('');
    }
  }

  resetControlBlockIfDataFieldNameNotFound(child) {
    let self = this;
    let typeName = child.getAttribute('type') || '';
    if(self.dataFieldNameBlocks.indexOf(typeName) != -1) {
      self.resetDataFieldBlockVal(child);
    }

    self.dataFieldNameBlocks.forEach((blockType) => {
      let childs = angular.element(child).find('block[type='+ blockType +']');
      if(childs.length) {
        childs.each((ind, item) => {
          self.resetDataFieldBlockVal(item);
        });
      }
    });
  }

  resetDataFieldBlockVal(item) {
    let self = this;
    item = angular.element(item);
    if(item.attr('type') == 'custom-date-diff') {
      let date1ControlName = item.find(' > field[name=DATE1]').text();
      if(self.controlDataFieldNames.indexOf(date1ControlName) == -1) {
        item.find(' > field[name=DATE1]').text('');
      }
      let date2ControlName = item.find(' > field[name=DATE2]').text();
      if(self.controlDataFieldNames.indexOf(date2ControlName) == -1) {
        item.find(' > field[name=DATE2]').text('');
      }
    }else {
      let controlName = item.find(' > field[name=CONTROL_NAME]').text();
      if(self.controlDataFieldNames.indexOf(controlName) == -1) {
        item.find(' > field[name=CONTROL_NAME]').text('');
        item.find(' > field[name=PROPERTY_VALUE]').text('');
      }
    }
  }

  setGlobleMethods() {
    var self = this;
    self.globleMethods = [];
    if(self.globleCodeEditor || !Blockly || !(<any>window)['globle'] || !(<any>window)['globle'].xmlVal) {
      return;
    }

    let xmlVal = Blockly.Xml.textToDom((<any>window)['globle'].xmlVal);
    if(!xmlVal) {
      return;
    }

    angular.element(xmlVal).children().each((ind, child) => {
        let $child = angular.element(child);
        let $type = $child.attr('type');
        
        if($type && ($type == 'procedures_defnoreturn' || $type == 'procedures_defreturn') && (self.allCustomBlocks.indexOf($type) == -1)) {
           let methodName = $child.find(' > field').text();
           if(methodName) {
             self.setGlobleMethodDefination(methodName, $type);
             self.globleMethods.push('fn_' + methodName);
           }
        }
    });
  }

  setGlobleMethodDefination(methodName, type = 'procedures_defnoreturn') {
    if(!methodName || this.globleMethods.indexOf('fn_' + methodName) != -1) {
      return;
    }

    Blockly.Blocks['fn_' + methodName] = {
      init: function() {
        this.appendDummyInput().appendField(new Blockly.FieldLabelSerializable(methodName), "NAME");
        if(type == 'procedures_defnoreturn') {
          this.setNextStatement(true, null);
          this.setPreviousStatement(true, null);
        }else {
          this.setOutput(true, null);
        }
        this.setColour(Blockly.Msg.PROCEDURES_HUE);
        this.setTooltip(Blockly.Msg.PROCEDURES_CALLNORETURN_TOOLTIP.replace('%1', methodName));
        this.setHelpUrl("");
      }
    };
    
    Blockly['JavaScript']['fn_' + methodName] = function(block) {
      let code = block.inputList[0].fieldRow[0].getValue().replace(/ /g, '_');
      return ' window.globleMethod(' + code + ' && '  + code + '()); \n';
    };
  }
  
  getVal(alertError) {
    let self = this;
    if(!self.codeEditor) {
      return;
    }

    try {
      let xmlDom = Blockly.Xml.workspaceToDom(self.codeEditor);
      let systemFields = [];
      let autoNumberFieldDetail = {};
      if(xmlDom) {
        let elSPValueComparator = angular.element(xmlDom).find('block[type=sp_value_comparator]');
        elSPValueComparator.each((ind, ele) => {
          let name = angular.element(ele).find('field[name=SP_NAME]').text();
          systemFields.push(name);
        });
        let elSPValueGetter = angular.element(xmlDom).find('block[type=sp_value_getter]');
        elSPValueGetter.each((ind, ele) => {
          let name = angular.element(ele).find('field[name=SP_NAME]').text();
          systemFields.push(name);
        });
        let CustomBlockName = angular.element(xmlDom).find('block[type=auto_next_number_block]');

        if(CustomBlockName.length) {
          CustomBlockName.each(function(index, block) {
            self.handleAutoNumberingBlock(xmlDom, block, autoNumberFieldDetail);
          })
        } else {
          self.handleAutoNumberingBlock(xmlDom, CustomBlockName, autoNumberFieldDetail);
        }

        // push userDetails field 
        const userDetailsField = angular.element(xmlDom).find('block[type="sp_user_details_getter"]')
        userDetailsField.length && systemFields.push('DS_USERDETAILS_FILTERED');
        
        var isAPIInProgress = false;
        if(Blockly.mainWorkspace && Blockly.mainWorkspace['topBlocks_'] && Blockly.mainWorkspace['topBlocks_'].length) {
          Blockly.mainWorkspace['topBlocks_'].forEach((e)=> {
            if( e.type == 'set_api_data' ) {
              isAPIInProgress = Blockly.mainWorkspace['isAPIInProgress'];
            }
          }); 
        }
      }
      return {
        scriptVal : Blockly['JavaScript'].workspaceToCode(self.codeEditor),
        xmlVal : Blockly.Xml.domToText(xmlDom),
        systemFields: systemFields,
        autoNumberFieldDetail: autoNumberFieldDetail,
        isAPIInProgress:isAPIInProgress
      }
    } catch(e) {
      if(alertError) {
        self.showEditorError();
      }
      return {
        scriptVal: '',
        xmlVal: '',
        systemFields: [],
        autoNumberFieldDetail: {},
        isAPIInProgress:false
      };
    }
  }

  handleAutoNumberingBlock(xmlDom, block, autoNumberFieldDetail) {
    let self = this;
    try {
      let blockName: string;
      const autoNumberBlock = angular.element(block);
      const isBlockInsideFunctionAndDisabled = self.isAutoNumberBlockDisabledAndInsideFunction(autoNumberBlock);
      // Checking for the disabled autonumbering
      isBlockInsideFunctionAndDisabled || autoNumberBlock.attr('disabled') || autoNumberBlock.length == 0 ? blockName = 'block[type=auto_next_number_suffix_block]' : blockName = 'block[type=auto_next_number_block]'
      
      let elAutoNumber = angular.element(xmlDom).find(blockName);
      elAutoNumber.length && elAutoNumber.each((ind, element) => {
        const isBlockDisableAndInsideFunc = self.isAutoNumberBlockDisabledAndInsideFunction(angular.element(element))
        if(isBlockDisableAndInsideFunc || angular.element(element).attr('disabled')) {
          return;
        }
        let fieldName = angular.element(element).find('field[name=AUTO_NUMBER_FIELD]').eq(0).text();
        let computedFieldNames: string[] = [];
        angular.element(element).find('field[name=CONTROL_NAME]').each(function(ind, fieldNameControl) {
          let name = angular.element(fieldNameControl).text();
          name && computedFieldNames.push(name);
        });

        autoNumberFieldDetail[fieldName] = {
          fieldName: fieldName,
          numberLength: parseInt(angular.element(element).find('field[name=AUTO_NUMBER_LENGTH]').text()) || 3,
          startFrom: parseInt(angular.element(element).find('field[name=AUTO_NUMBER_START_FROM]').text()) - 1 || 0,
          autoNumberPosition: angular.element(element).find('field[name=AUTO_NUMBER_POSITION]').text() || 'POSTFIX',
          autoNumberStringCheck: angular.element(element).find('field[name=AUTO_NUMBER_STRINGCHECK]').text() || 'YES',
          autoNumberSeparator: angular.element(element).find('field[name=AUTO_NUMBER_SEPARATOR]').text() || '-',
          autoNumberComputedFieldName: computedFieldNames,
        }
      });
    } catch(err) {
      self.showEditorError();
    }
  }

  isAutoNumberBlockDisabledAndInsideFunction(block) {
    const isBlockDisableInsideFn = block.closest('block[type="procedures_defnoreturn"][disabled="true"]') || block.closest('block[type="procedures_defreturn"][disabled="true"]'); // checking for the disabled function which contains the autonumbering
    if(isBlockDisableInsideFn.length) {
      return true;
    }
    
    return false;
  }

  showEditorError() {
    let self = this;
    self.ngNotification.error({
        message: `Please enter a valid script code.`,
        positionX: 'center',
        replaceMessage: true
    });
  }

  resizeHandler() {
    let self = this;
    if(!self.codeEditor) {
      return;
    }

    let height = (self.maximized) ? <any>window.innerHeight - 180 : Math.max(500, (<any>window).innerHeight) - 180;
    let margin = (self.maximized) ? 0 : (<any>window.innerWidth <= 768) ? 10 : 30;
    self.$element.find('#codeEditorWindow').css('height', (height - (margin * 2)) + 'px');
    Blockly.svgResize(self.codeEditor);
  }

  getGlobleMethodsDetail() {
    let self = this;
    let globleMethodDetails = {};

    if(!Blockly || !(<any>window)['globle'] || !(<any>window)['globle'].xmlVal) {
      return globleMethodDetails;
    }

    let xmlVal = Blockly.Xml.textToDom((<any>window)['globle'].xmlVal);
    if(!xmlVal) {
      return globleMethodDetails;
    }

    angular.element(xmlVal).children().each((ind, child) => {
        let $child = angular.element(child);
        let $type = $child.attr('type');
        if($type && ($type == 'procedures_defnoreturn' || $type == 'procedures_defreturn') && (self.allCustomBlocks.indexOf($type) == -1)) {
           let methodName = $child.find(' > field').text();
           globleMethodDetails[$child.attr('id')] = methodName;
        }
    });

    return globleMethodDetails;
  }
  
  /**
   * @brief      Destroy existing code editer intanceview.
   *
   * @return     null
   */
  destroyCodeEditor() {
    let self = this;
    if(!self.codeEditor) {
      return;
    }

    self.codeEditor.clear();
    (<any>window)['codeEditor'] = undefined;
    self.codeEditor = undefined;
    self.codeEditorVal = undefined;
    angular.element((<any>window)).off('resize.blocklyeditor');
  }

}

export const convertXMLStringToNode = function(xmlVal) {
  return Blockly.Xml.textToDom(xmlVal);
};

export const getAllValueSetterControlName = function(xmlVal) {
  if(!xmlVal) {
    return [];
  }

  let xmlNode = Blockly.Xml.textToDom(xmlVal);
  let valueBlocks = [];
  let setterBlocks = angular.element(xmlNode).find('block[type="custom-property-setter"]')
  setterBlocks.each((ind, setterBlock) => {
    if(angular.element(setterBlock).find('field[name=PROPERTY_NAME]').text() == 'value') {
      valueBlocks.push(angular.element(setterBlock).find('field[name=CONTROL_NAME]').text());
    }
  });
  return valueBlocks;
};

export default angular.module('directives.asiteBlockly', []).component('asiteBlockly', {
  template: require('./blockly.html'),
  controller: BlocklyComponent,
  bindings: {
    globleCodeEditor: '<',
    maximized: '<'
  }
}).name;



// WEBPACK FOOTER //
// ./client/components/blockly/blockly.component.ts